$(document).ready(function() {


    $('.categoryDesc-firstPart').find('span').on('click', function () {
        $('.categoryDesc-secoundPart').fadeIn("slow");
        $(this).fadeOut("slow");
    });
    
    $('.categoryDesc-secoundPart').find('span').on('click', function () {
        $('.categoryDesc-secoundPart').fadeOut("slow");
        $('.categoryDesc-firstPart').find('span').fadeIn("slow");
    });
        
        //login page - inputs
        var loginInputs = $('.AccountTable').find('input[type="text"] , input[type="email"]');
        for (var i = 0; i < loginInputs.length; i++) {
            if ($(loginInputs[i]).val() != '') {
                $(loginInputs[i]).closest('tr').find('.AccountTextCell').addClass('input-focus');
            }
        }
        $(loginInputs).on('focus', function() {
            $(this).closest('tr').find('.AccountTextCell').addClass('input-focus');
        });
        $(loginInputs).focusout(function() {
            if ($(this).val() == '') {
                $(this).closest('tr').find('.AccountTextCell').removeClass('input-focus');
            }
    
        });

        
    
        var shipPrices = $('.ShoppingCartShippingRadioButtonList').find('b,strong');
        var shipLi = $('.ShoppingCartShippingRadioButtonList').find('li');
        for (var i = 0; i < shipLi.length; i++) {
            $(shipPrices[i]).clone().appendTo(shipLi[i]);
        }
    
    
        $("body").on("contextmenu", "img", function() {
            return false;
        });
    
    
    });
    
    
    
    $(document).ready(function() {

        //inscription 
        $('.inscriptionQuestion').click(function() {
            $(this).toggleClass('open');
        });
    
        if ($('.inscriptionQuestion').length > 0) {
            $('.ProductBulletCell').hide();
            //arrows
            $('.inscriptionQuestion').on('click', function() {
                $(this).siblings('.inscriptionAnswer').slideToggle();
                $(this).closest('.inscriptionBoxWrap').toggleClass('link-open');
            });
        }
    
    
     
    
        // GA EVENT --- "filter view" button
        $(".search-filter-view").on("click", function() {
    
            var prodLink = document.location.href;
            var list = prodLink.split("?")[1].split("=")[1].split("&")[0];
            var eventLabel = "drawer_submit_" + list;
    
            ga('send', {
                hitType: 'event',
                eventCategory: "category_page",
                eventAction: "click",
                eventLabel: eventLabel
            });
    
        });
    
        // "filter" button
        $(".category-page .filter-button-div").on("click", function() {
    
            var prodLink = document.location.href;
            var list = prodLink.split("?")[1].split("=")[1].split("&")[0];
            var eventLabel = "open_filter_drawr_" + list;
    
            ga('send', {
                hitType: 'event',
                eventCategory: "category_page",
                eventAction: "click",
                eventLabel: eventLabel
            });
    
        });
    
        // "Filter clear all" button click GA Event
        $(".search-filter-reset").on("click", function() {
    
            var prodLink = document.location.href;
            var list = prodLink.split("?")[1].split("=")[1].split("&")[0];
            var eventLabel = "clear_all_" + list;
    
            ga('send', {
                hitType: 'event',
                eventCategory: "category_page",
                eventAction: "click",
                eventLabel: eventLabel
            });
    
        });
    

        $(document).on('click', '.sendSurveyBtn', function(){
    
            // survey question 1
            eventLabel = 'survey_q1_' +  $('.surveyContent .question_1 input[name=question_1]:checked').val() 
          
            ga('send', {
                hitType: 'event',
                eventCategory: "thank_you_page",
                eventAction: "click",
                eventLabel: eventLabel
            });
          
            q2_val = $('.surveyContent .question_2 input[name=question_2]:checked').val()
          
            // survey question 2
            if(q2_val == "other"){
              eventLabel = 'survey_q3_' + $(".AnswerOther").val().trim().split(" ").join("_");
            }
            else{
              eventLabel = 'survey_q2_' + q2_val;
            }
          
            ga('send', {
                hitType: 'event',
                eventCategory: "thank_you_page",
                eventAction: "click",
                eventLabel: eventLabel
            });
          
          });
    });